import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Templ from './Templ.jsx'
//import _ from 'lodash'

class TemplatesComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    return <div><Templ employee={this.props.employee}></Templ></div>
  }
}

TemplatesComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
}

export default TemplatesComponent
